import { Fragment } from 'react';
import { useAppSelector } from '@redux/hooks';
import { getSeoBlocks } from '@entities/Seo/module/selectors/getSeoBlocks';
import { blockType } from '@entities/Seo/module/types/seoSchema';
import { GridLinks, RowLinks } from '@app/shared';

import styles from './seoBlocks.module.scss';
import { useWindowSizing } from '@hooks/useSizeWindow';

export const SeoBlocks = () => {
  const blocks = useAppSelector(getSeoBlocks);

  if (!blocks || !blocks.length) {
    return null;
  }

  return <Fragment>{blocks?.map((block, index) => <SeoBlocks.Block key={index} block={block} />)}</Fragment>;
};

SeoBlocks.Block = function Block({ block }: { block: blockType }) {
  const isMobile = useWindowSizing(990);
  return (
    <div id={block.idBlock} className={styles.Wrapper}>
      <div className={styles.Title}>{block.title}</div>
      {isMobile ? <RowLinks links={block.links} className={styles.Links} /> : <GridLinks links={block.links} />}
    </div>
  );
};
